module.exports = __webpack_public_path__ + "img/product6.d0dcef17.png";